export default __webpack_public_path__ + "static/29392-a1fa5e169f288f4b944969cf928189ad.jpg";